
export function Introduction() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-4xl mx-auto px-6 lg:px-8">
        <div className="text-center space-y-6">
          <div className="inline-block">
            <span className="text-primary text-xs font-bold tracking-widest uppercase bg-primary/10 px-4 py-2 rounded-full">
              WE GET IT
            </span>
          </div>

          <div className="border-l-4 border-primary pl-8 text-left space-y-6">
            <p className="text-xl lg:text-2xl text-gray-700 leading-relaxed font-light">
              You didn’t start your business to become a tech expert — you started it to serve customers and grow.
            </p>
            <p className="text-xl lg:text-2xl text-gray-700 leading-relaxed font-light">
              But missed calls, slow follow-up, and scattered scheduling are quietly costing you appointments and revenue every day.
            </p>
            <p className="text-xl lg:text-2xl text-gray-700 leading-relaxed font-light">
              Dino Nuggets helps you answer faster, follow up automatically, and book more jobs without adding more work to your plate.
            </p>
            <p className="text-xl lg:text-2xl text-gray-700 leading-relaxed font-light">
              Our AI assistants respond instantly, handle common questions, and keep the conversation moving 24/7.
            </p>
            <p className="text-xl lg:text-2xl text-gray-700 leading-relaxed font-light">
              You don’t need to learn complicated software or manage a dozen tools — we handle the setup behind the scenes while you focus on running your business.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
